import { createSlice } from "@reduxjs/toolkit";

const TagSlice = createSlice({
    name: "Tags",
    initialState:{
        items:[]
    },
    reducers:{
        addTags:(state, action)=>{
            state.items.push(action.payload)
        },
        removeTag:(state, action)=>{
            state.items.pop(action.payload)
        }
    }
})

export const {addTags, removeTag} = TagSlice.actions;

export default TagSlice.reducer;